import { render } from "./HowCategoryRatingsChart.vue?vue&type=template&id=0c346d3e&ts=true"
import script from "./HowCategoryRatingsChart.vue?vue&type=script&lang=ts"
export * from "./HowCategoryRatingsChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__